/**
 * Исходное регулярное выражение (удалить переносы строк):
 * /
 *  (?:^|[^\w\d@\-.]|[А-Яа-я]\s?-?|[^A-Za-z\d]\.)
 *  ((https?:\/\/)?[a-zA-Z\d][a-zA-Z\d\-_]+[a-zA-Z\d\-_.]*\.(
 *  aero|am|art|biz|center|city|city-lab|clinic|club|com|company|es|expert|group|in|info|la|life|md|me|moscow|mu|
 *  name|net|org|pro|pw|ru|ruservices|site|studio|su|tk|to|tv|ua|vc|москва|онлайн|рус|рф|сс
 *  )([/a-zA-Z_\-\d.]+)?)
 *  (?:[^\w\d.@]|$|\.?[А-Яа-я\s])
 * /g
 * Ниже использовано значение свойства `source` этого выражения, чтобы можно было разбить на строки.
 */
const regExp = new RegExp('(?:^|[^\\w\\d@\\-.]|[А-Яа-я]\\s?-?|[^A-Za-z\\d]\\.)'
    + '((https?:\\/\\/)?[a-zA-Z\\d][a-zA-Z\\d\\-_]+[a-zA-Z\\d\\-_.]*\\.('
    + 'aero|am|art|biz|center|city|city-lab|clinic|club|com|company|es|expert|group|in|info|la|life|md|me|moscow|mu|'
    + 'name|net|org|pro|pw|ru|ruservices|site|studio|su|tk|to|tv|ua|vc|москва|онлайн|рус|рф|сс'
    + ')([/a-zA-Z_\\-\\d.]+)?)'
    + '(?:[^\\w\\d.@]|$|\\.?[А-Яа-я\\s])', 'g')

function filterRemoveSite(text: string, allowedHosts: string[] = []) {
  let transformedText = text;

  [...text.matchAll(regExp)].forEach(match => {
    if (match.length < 2) {
      return
    }

    const site = match[1].trim().toLowerCase()

    if (!site || allowedHosts.some(host => site.includes(host.toLowerCase()))) {
      return
    }

    transformedText = transformedText.replace(site, '[...]')
  })

  return transformedText
}

export default filterRemoveSite
